import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { I18nService, TranslateService } from 'i18n';

@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanActivate {
  constructor(private i18nService: I18nService, private translateService: TranslateService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const lang = route.paramMap.get('lang');
    const supportedLanguages = this.translateService.getAvailableLangs(); //['en', 'de'];
    if (lang && supportedLanguages.includes(lang)) {
      this.i18nService.setLanguage(lang, false); // sync without navigating
      return true;
    }
    // redirect to default language
    const defaultLang = this.i18nService.getLanguage();
    const urlSegments = route.url.map(segment => segment.path);
    urlSegments[0] = defaultLang;
    this.router.navigate(urlSegments);
    return false;
  }
}